import { FavoriteVehicleTypeDTO, type FavoriteItemDTO } from "@packages/domain";

const PORTAL_HOSTS = {
  production: "https://www.webmotors.com.br",
  blue: "https://azulportal.webmotors.com.br",
  hml: "https://hportal.webmotors.com.br",
  local: "https://hportal.webmotors.com.br",
} as const;

function isDigit(c: string): boolean {
  return c >= "0" && c <= "9";
}

function isLowerAlpha(c: string): boolean {
  return c >= "a" && c <= "z";
}

function isDiacritic(c: string): boolean {
  const code = c.charCodeAt(0);
  return code >= 0x0300 && code <= 0x036f;
}

function extractCubicCentimeter(model: string | undefined): string {
  if (!model) return "";
  let current = "";
  for (const c of model) {
    if (isDigit(c)) {
      current += c;
    } else {
      if (current.length >= 2 && current.length <= 4) return current;
      current = "";
    }
  }
  if (current.length >= 2 && current.length <= 4) return current;
  return "";
}

export function getPortalHost(): string {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT ?? "local";
  return (
    PORTAL_HOSTS[env as keyof typeof PORTAL_HOSTS] ?? PORTAL_HOSTS.local
  );
}

export function buildSimulatorUrl(): string {
  return `${getPortalHost()}/financiamento/simulador-financiamento?lkid=1376`;
}

function slugify(value: string): string {
  const normalized = value.toLowerCase().normalize("NFD");
  const chars: string[] = [];
  for (const c of normalized) {
    if (isDiacritic(c) || c === ".") continue;
    if (isLowerAlpha(c) || isDigit(c)) {
      chars.push(c);
    } else if (chars.length > 0 && chars[chars.length - 1] !== "-") {
      chars.push("-");
    }
  }
  while (chars.length > 0 && chars[chars.length - 1] === "-") {
    chars.pop();
  }
  return chars.join("");
}

export function buildDetailUrl(favorite: FavoriteItemDTO): string {
  const host = getPortalHost();
  const segments = ["comprar"];
  const isBike = favorite.vehicleType === FavoriteVehicleTypeDTO.BIKE;

  if (favorite.brand) segments.push(slugify(favorite.brand));
  if (favorite.model) segments.push(slugify(favorite.model));

  if (isBike) {
    const cc = extractCubicCentimeter(favorite.model);
    if (cc) segments.push(`${cc}cc`);
  } else {
    if (favorite.version) segments.push(slugify(favorite.version));
    if (favorite.numberPorts) segments.push(`${favorite.numberPorts}-portas`);
  }

  if (favorite.yearModel) segments.push(String(favorite.yearModel));
  if (favorite.advertiseId) segments.push(String(favorite.advertiseId));

  return `${host}/${segments.join("/")}`;
}
